import getCustomNodes from '../../../../constants/getCustomNodes';

/**
 * * v6: Update for OSU requirement to remove fromDate from education
 * * The structure is changed according to the current version updateVersion props.
 */
export default (params) => {
  const { fieldType, fieldData, updateVersion, universityPlan } = params;

  const {
    document: { nodes: documentNodes },
  } = fieldData;

  let updatedOrganizationNodes = [];

  documentNodes.forEach((organizations) => {
    const { nodes: organizationNodes, type } = organizations;

    if (type === 'empty_paragraph') {
      return;
    }

    const roleDetails = organizationNodes[1];

    const filteredRoleNode = getCustomNodes({
      universityPlan,
      defaultNodes: roleDetails.nodes,
      sectionKey: fieldType,
    });

    const updatedRoleDetails = {
      ...roleDetails,
      nodes: filteredRoleNode,
    };
    const updatedOrganizations = {
      ...organizations,
      nodes: [organizationNodes[0], updatedRoleDetails],
    };

    updatedOrganizationNodes = [
      ...updatedOrganizationNodes,
      updatedOrganizations,
    ];
  });

  const updatedOrganizations = {
    ...fieldData,
    document: {
      ...fieldData.document,
      data: {
        ...fieldData.document.data,
        version: {
          number: updateVersion,
          updated: true,
        },
      },
      nodes: updatedOrganizationNodes,
    },
  };

  return { [fieldType]: updatedOrganizations };
};
